import { useQuery } from "@tanstack/react-query";
import { getWeldlineOverview } from "../repositories/overviewRepository";
import { OverviewData } from "../models/types";

interface UseOverviewDataProps {
	assetId?: number | null;
	onError?: (error: Error) => void;
}

export const useOverviewData = ({
	assetId = null,
	onError,
}: UseOverviewDataProps = {}) => {
	const { data, isLoading, refetch } = useQuery<OverviewData, Error>({
		queryKey: ["weldlineOverview", assetId],
		queryFn: () => getWeldlineOverview(assetId),
		refetchInterval: 10000,
		refetchOnWindowFocus: true,
		onError,
	});

	return {
		data,
		isLoading,
		refetch,
	};
};
